export const SPINNER_ENGAGED = 'Spinner Engaged';
export const PRE_ORDER_CANCELED = 'Pre-order Cancelled';

export enum ClientId {
  DEFAULT = 'default',
  GIVEAWAY_UI = 'giveaway_ui',
  HOME_UI = 'home_ui',
  SEM_UI = 'sem_ui',
  SRP_UI = 'srp_ui',
  USED_EV_TAX_CREDIT_UI = 'used_ev_tax_credit_ui',
  VDP_UI = 'vdp_ui'
}
